import React from "react";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
registerLocale("es", es);
import { expensesService, expStatus } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";

class ExpensePaymentModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			paid_at: "",
			payer_id: props.currentUser?.id || "",
			payer_comments: props.expense.payer_comments || "",
		};
	}

	handleChange = (event) => {
		this.setState({ [event.target.id]: event.target.value });
	};

	handleDateChange = (date) => {
		this.setState({ paid_at: date ? moment(date).format("YYYY-MM-DD") : "" });
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		const { paid_at, payer_id, payer_comments } = this.state;

		if (!payer_id) {
			this.setState({ submitted: true, errors: { payer_id: this.props.t('expenses.paymentModal.payerRequired') } });
			return;
		}

		this.setState({ isLoading: true });

		const { expense } = this.props;

		const updated = {
			...expense,
			type_id: expense.type_id ?? expense.type?.id,
			provider_id: expense.provider_id ?? expense.provider?.id,
			paid_at,
			payer_id: payer_id || undefined,
			payer_comments,
			status: expStatus.paid,
		};

		const response = await expensesService.update(updated);

		if (response.ok) {
			this.setState({ isLoading: false, errors: {} }, () => {
				toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
				this.props.getExpenses();
				this.props.handleClose();
			});
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { employees } = this.props;
		const { paid_at, payer_id, payer_comments, isLoading, errors } = this.state;

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					{errors.general && (
						<InlineAlert variant="error" className="mb15">
							{errors.general}
						</InlineAlert>
					)}
					<FormGroup
						controlId="paid_at"
						className={`form-group form-date ${paid_at === "" && "empty"} ${this.checkValidField("paid_at") && "is-invalid"}`}
					>
						<FormLabel>
							{this.props.t('expenses.paymentModal.paymentDate')} <span className="label-required">*</span>
						</FormLabel>
						<DatePicker
							selected={paid_at ? moment(paid_at).toDate() : null}
							onChange={this.handleDateChange}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText="dd/mm/aaaa"
						/>
						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{this.state.errors.paid_at}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="payer_id" className="form-group">
						<FormLabel>{this.props.t('expenses.paymentModal.payer')}</FormLabel>
						<FormControl
							as="select"
							value={payer_id}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("payer_id")}
						>
							<option value="">{this.props.t('expenses.paymentModal.selectPayer')}</option>
							{employees?.map((e) => (
								<option key={e.id} value={e.id}>
									{e.name} {e.surname}
								</option>
							))}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{this.state.errors.payer_id}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="payer_comments" className="form-group">
						<FormLabel>{this.props.t('expenses.paymentModal.observations')}</FormLabel>
						<FormControl
							as="textarea"
							value={payer_comments}
							onChange={this.handleChange}
							placeholder={this.props.t('expenses.paymentModal.observationsPlaceholder')}
							isInvalid={this.checkValidField("payer_comments")}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.payer_comments}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={isLoading}
						text={this.props.t('common.save')}
						loadingText={this.props.t('common.saving')}
					/>
				</div>
			</form>
		);
	}
}

export default withTranslation()(ExpensePaymentModal);
